import React from 'react';
import { X } from 'lucide-react';
import { AdminImageStyle, ImageStyleCreateRequest, ImageStyleUpdateRequest, ImageStyleCategory } from '../../services/api/adminImageStyleService';
import ImageStyleForm from './ImageStyleForm';

interface ImageStyleFormModalProps {
  isOpen: boolean;
  imageStyle?: AdminImageStyle | null;
  existingCategories: ImageStyleCategory[];
  onSubmit: (data: ImageStyleCreateRequest | ImageStyleUpdateRequest) => void;
  onClose: () => void;
  isLoading?: boolean;
}

const ImageStyleFormModal: React.FC<ImageStyleFormModalProps> = ({
  isOpen,
  imageStyle,
  existingCategories,
  onSubmit,
  onClose,
  isLoading = false
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal="true"
    >
      <div className="flex max-h-[90vh] w-full max-w-2xl flex-col overflow-hidden rounded-tasky-lg bg-white shadow-card">
        <div className="flex shrink-0 items-center justify-between border-b border-warm-border px-6 py-4">
          <h5 className="text-lg font-semibold text-dark">
            {imageStyle ? '画像スタイル編集' : '画像スタイル新規作成'}
          </h5>
          <button
            type="button"
            className="text-gray-400 transition-colors hover:text-gray-600 disabled:cursor-not-allowed disabled:opacity-50"
            onClick={onClose}
            disabled={isLoading}
            aria-label="閉じる"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="overflow-y-auto px-6 py-4">
          <ImageStyleForm
            imageStyle={imageStyle}
            existingCategories={existingCategories}
            onSubmit={onSubmit}
            onCancel={onClose}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageStyleFormModal;
